import { render } from "./ProtectInformationPostPage.vue?vue&type=template&id=6cb77c23"
import script from "./ProtectInformationPostPage.vue?vue&type=script&lang=js"
export * from "./ProtectInformationPostPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__